import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'components/inputs'

export default class RowSelector extends Component {
  static propTypes = {
    enabled: PropTypes.bool,
    selected: PropTypes.bool,
    setSelected: PropTypes.func.isRequired
  }

  render() {
    const {
      enabled,
      selected,
      setSelected
    } = this.props

    return (
      <Checkbox
        labelless
        inTable
        label=""
        name="isSelected"
        checked={selected}
        disabled={!enabled}
        onChange={setSelected}
      />
    )
  }
}
